<div class="wab_timer">
    <span class="wab-clockTimer sprite">
        <img [src]="getImg('clockTimer')" alt="clockTimer" srcset="">
    </span>
    <progress [value]="remainingTime" [max]="playTime"> </progress>
</div>